/**
 * 故障分析报表
 */

// 公共方法
import { setStoreApiDate } from '../utils'

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    // 获取统计数据
    async fetchGetMonthAnalyzeCount({ commit, getters }, params) {
      const { getMonthAnalyzeCount } = getters.getHttps
      const { data } = await getMonthAnalyzeCount(params)
      return setStoreApiDate(data, commit)
    },

    // 获取故障详情分页列表
    async fetchGetMonthAnalyzePage({ commit, getters }, params) {
      const { getMonthAnalyzePage } = getters.getHttps
      const { data } = await getMonthAnalyzePage(params)
      return setStoreApiDate(data, commit)
    }
  }
}
